import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { RecordListViewMode } from '../record-list/record-list.types';

export type BusinessDocumentViewMode = RecordListViewMode;

export interface BusinessDocumentListViewState {
  visible: boolean;
  mode: BusinessDocumentViewMode;
  availableModes: BusinessDocumentViewMode[];
}

@Injectable({
  providedIn: 'root',
})
export class BusinessDocumentListView {
  private readonly stateSubject = new BehaviorSubject<BusinessDocumentListViewState>({
    visible: false,
    mode: 'list',
    availableModes: ['list'],
  });
  private activeRegistration: symbol | null = null;

  readonly state$ = this.stateSubject.asObservable();

  get state(): BusinessDocumentListViewState {
    return this.stateSubject.value;
  }

  register(
    initialMode: BusinessDocumentViewMode = 'list',
    availableModes: BusinessDocumentViewMode[] = ['list', 'kanban'],
  ): symbol {
    const registration = Symbol('business-document-list-view');
    this.activeRegistration = registration;
    const modes = [...new Set(availableModes)];
    const mode = modes.includes(initialMode) ? initialMode : (modes[0] ?? 'list');
    this.stateSubject.next({ visible: modes.length > 1, mode, availableModes: modes });
    return registration;
  }

  release(registration: symbol): void {
    if (this.activeRegistration !== registration) {
      return;
    }
    this.activeRegistration = null;
    this.stateSubject.next({ visible: false, mode: 'list', availableModes: ['list'] });
  }

  setMode(mode: BusinessDocumentViewMode): void {
    if (!this.state.visible || this.state.mode === mode || !this.state.availableModes.includes(mode)) {
      return;
    }
    this.stateSubject.next({ ...this.state, mode });
  }
}
